import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
 
import React, { ReactNode, useEffect, useState } from 'react';
import Layout from '../layout/layout';
import AbuseReport from '../Pages/adminActions/AbuseReport';
import { LoginPage } from '../Pages/auth/login';
import { DashboardPage } from '../Pages/dashboard/dashboard';
import Fighters from '../Pages/fighters/Fighter';
import History from '../Pages/History/history';
import Managerlist from '../Pages/managers/managerlist';
import Deals from '../Pages/myDeals/deals';
import PendingList from '../Pages/pendinglist/pendinlist';
import PublicProfile from '../Pages/profile/publicProfile';
import PublicViewProfile from '../Pages/profile/publicViewProfile';
import Settings from '../Pages/settings/settings';
import { checkAuthentication } from '../services/api';
import Feeds from '../Pages/Feeds/feeds';
import Post from '../Pages/Feeds/post';
import ViewDealPage from '../Pages/myDeals/viewDeal';
import MarketplaceCards from '../Pages/marketPlaceCards/marketPlaceCards';

 
type RouteProps = {
    children: ReactNode;
};
 
const ProtectedRoute: React.FC<RouteProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const location = useLocation();
 
    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await checkAuthentication();
                setIsAuthenticated(response === true);
            } catch (error) {
                setIsAuthenticated(false);
            }
        };
 
        checkAuth();
    }, []);
 
    if (isAuthenticated === null) {
        return <div>Loading...</div>;
    }
 
    if (!isAuthenticated) {
        return <Navigate to="/" state={{ from: location.pathname }} replace />;
    }
 
    return <>{children}</>;
};
 
const PublicRoute: React.FC<RouteProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const location = useLocation();
 
    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await checkAuthentication();
                setIsAuthenticated(response === true);
            } catch (error) {
                setIsAuthenticated(false);
            }
        };
 
        checkAuth();
    }, []);
 
    if (isAuthenticated === null) {
        return <div>Loading...</div>;
    }
 
    if (isAuthenticated) {
        return <Navigate to={location.state?.from || '/dashboard'} replace />;
    }
 
    return <>{children}</>;
};
 
const ProtectedLayout: React.FC = () => {
    return (
        <Layout>
            <Outlet />
        </Layout>
    );
};
 
const Root: React.FC = () => {
    return (
        <Routes>
            <Route path="/view-profile" element={<PublicViewProfile />} />
 
            <Route path="/" element={<PublicRoute><LoginPage /></PublicRoute>} />
            <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
 
            <Route
                element={
                    <ProtectedRoute>
                        <ProtectedLayout />
                    </ProtectedRoute>
                }
            >
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/fighters" element={<Fighters />} />
                <Route path="/manager" element={<Managerlist />} />
                <Route path="/history" element={<History />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/profile" element={<PublicProfile />} />
                <Route path="/abuseReport" element={<AbuseReport />} />
                <Route path="/mydeals" element={<Deals />} />
                <Route path="/pending" element={<PendingList />} />
                <Route path="/feeds" element={<Feeds />} />
                <Route path="/view-post/:postId" element={<Post />} />
                <Route path="/deal/view/:id" element={<ViewDealPage />} />
                 <Route path="/marketPlaceCards" element={<MarketplaceCards />} />
            </Route>
 
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};
 
export default Root
